import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import {
  DominateOptionItemSquare,
  DominateOptionItemSquareList,
} from '@/pages/Onboarding/Layouts/OwnAI_Dominate/components/DominateOptionItemSquare';
import { DOMINATRIX_VISUAL_STYLE_OPTIONS } from '@/pages/Onboarding/options/DominatrixVisualStyle/DOMINATRIX_VISUAL_STYLE_OPTIONS';
import { DominatrixVisualStyleOptionIdType } from '@/pages/Onboarding/options/DominatrixVisualStyle/types';
import { getDominatrixVisualStyleTitleById } from '@/pages/Onboarding/options/DominatrixVisualStyle/utils/getDominatrixVisualStyle';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../components/Title';
import { LayoutDataType } from '../../types';

import { PageStyles } from './DominatrixVisualStyle.styles';

export const ScreenDominatrixVisualStyle: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Dominatrix Visual Style',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const controlStyle = form.watch('dominatrix_visual_style');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['dominatrix_visual_style']>,
  ) => {
    form.setValue('dominatrix_visual_style', option.id);
  };

  const getImageSrc = (
    id: OnbOptionType<DominatrixVisualStyleOptionIdType>['id'],
  ) => {
    return `/assets/layout-own-ai-dominate/dominatrix_visual_style/${id}.png`;
  };

  const handleNextStep = () => {
    userService.createOrUpdate({
      onboarding_data: {
        dominatrix_visual_style:
          getDominatrixVisualStyleTitleById(controlStyle),
      },
    });
    wizard.nextStep();
  };

  return (
    <PageStyles background={'domination'}>
      <OnboardingNavigation />
      <OwnAiTitle>
        How do you want your dominatrix to break you... visually?
      </OwnAiTitle>

      <IonContent>
        <DominateOptionItemSquareList>
          {DOMINATRIX_VISUAL_STYLE_OPTIONS.map((option) => (
            <DominateOptionItemSquare
              key={option.id}
              isSelected={controlStyle === option.id}
              onClick={() => handleSelect(option)}
              bgSrc={getImageSrc(option.id)}
              title={option.title}
              TEST_ID={`dominantrix-visual-style-${option.id}`}
            />
          ))}
        </DominateOptionItemSquareList>
      </IonContent>

      {controlStyle && (
        <OnboardingFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          disabled={!controlStyle}
          buttonClassName={'page-footer'}
        />
      )}
    </PageStyles>
  );
};
